import React from 'react';

const NotFound = () => {
  return <div className="container-fluid">Page not found</div>;
};

export default NotFound;
